<template>
  <div>
    <span class="ml-2 mr-2" :class="!isOpen ? 'active-vote-class' : ''">{{ $t("agenda.Approved") }}:{{ approvedCount }}</span> 
      <span class="mr-2" :class="!isOpen ? 'active-vote-class' : ''">{{ $t("agenda.Rejected") }}:{{ rejectCount }}</span> 
      <span class="mr-2" :class="!isOpen ? 'active-vote-class' : ''">{{ $t("agenda.Abstained") }}:{{ abstainedCount }}</span> 
      <span class="mr-2" :class="!isOpen ? 'active-vote-class' : ''">{{ $t("agenda.lblNotActed") }}:{{ notVotedCount }}</span> 
      <span class="ml-4 mr-2" :class="!isOpen ? 'active-vote-class' : ''" >{{ $t("agenda.btnNoObjection") }}:{{ noObjectionCount }}</span>
      <span class="mr-2" :class="!isOpen ? 'active-vote-class' : ''" >{{ $t("agenda.btnHasObjection") }}:{{ hasObjectionCount }}</span> 
      <span class="mr-2" :class="!isOpen ? 'active-vote-class' : ''" >{{ $t("agenda.lblNotActed") }}:{{ notConsentCount }}</span> 
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "ApprovalStatus",
  components: {
  },
  data() {
    return {
      
    };
  },
  props: {
    isAuditorsConsent:{
      type: Boolean,
      default: false,
    },
    topicData: {
      type: Object,
      default: null,
    },
    meetingObj: {
      type: Object,
      default: null,
    },
  },
  mounted() {
  },
  computed: {
    ...mapState({
      meetingVotingData: (state) => state.meeting.meetingVotingData,
    }),
    isOpen() {
      if(this.topicData.approval){
        return Boolean(this.topicData.approval.isOpen);
      }else{
        return false
      }
      
    },
    authorizedAttendees(){
      if(this.meetingObj.attendees){
        return this.meetingObj.attendees.filter(user => user.is_authorized);
      }
      return []
    },
   topicDataStats(){
    if(!this.meetingVotingData){
      return this.topicData;
    }
      const foundTopic = this.meetingVotingData.find(topic => topic.Id === this.topicData.Id);
      if(foundTopic){
        return foundTopic;
      }
      return this.topicData;
    
   },
   approvedCount(){
    if(!this.topicDataStats.votes){
      return 0
    }
      const approve = this.topicDataStats.votes.find(item => item.approvalStatus === 'approve')
      return approve ? approve.voteCount : 0
   },
   rejectCount(){
    if(!this.topicDataStats.votes){
      return 0
    }
      const reject = this.topicDataStats.votes.find(item => item.approvalStatus === 'reject')
      return reject ? reject.voteCount : 0
   },
  abstainedCount(){
    if(!this.topicDataStats.votes){
        return 0
      }
      const abstained = this.topicDataStats.votes.find(item => item.approvalStatus === 'abstain')
      return abstained ? abstained.voteCount : 0
   },
   notVotedCount(){
    if(!this.topicDataStats.votes){
        return 0
      }
      const not_voted = this.topicDataStats.votes.find(item => item.approvalStatus === 'not_voted')
      return not_voted ? not_voted.voteCount : 0
   },
   hasObjectionCount(){
    if(!this.topicDataStats.consents){
        return 0
      }
      const hasObjection = this.topicDataStats.consents.find(item => item.consentStatus === 'hasObjection')
      return hasObjection ? hasObjection.voteCount : 0
   },
   noObjectionCount(){
    if(!this.topicDataStats.consents){
        return 0
      }
      const noObjection = this.topicDataStats.consents.find(item => item.consentStatus === 'noObjection')
      return noObjection ? noObjection.voteCount : 0
   },
   notConsentCount(){
    if(!this.topicDataStats.consents){
        return 0
      }
      const not_consent = this.topicDataStats.consents.find(item => item.consentStatus === 'not_consent')
      return not_consent ? not_consent.voteCount : 0
   },
   notActedVoteCount(){
    if(this.topicDataStats.votes){
      const totalVotes = this.topicDataStats.votes.reduce((total, vote) => total + vote.voteCount, 0);
      return totalVotes - this.authorizedAttendees.length
    }else{
      return this.authorizedAttendees.length
    }
    

   }

  },

  methods: {
   
  },
};
</script>
<style scoped>
.active-vote-class{
  color: #cccccc !important;
}
</style>